import React from 'react';
import { useAppConfig } from '../../AppConfig';
import { useFeatureToggles } from '../useFeatureToggles';
import { Counter } from './Counter';
import { MapLink } from './MapLink';
import { Sorting } from './Sorting';
import { LayoutToggle } from './layout/LayoutToggle';

type ResultsToolbarProps = {
    className?: string;
};

export function ResultsToolbar(props: ResultsToolbarProps) {
    const { className = '' } = props;

    const { isProbablyMobile } = useAppConfig();
    const { hideMapLink } = useFeatureToggles();

    const showCounter = !isProbablyMobile || hideMapLink;

    return showCounter ? (
        <div className={`flex justify-between items-center ${className}`}>
            <Counter />
            <div className="flex space-x-8">
                <div className="flex space-x-8">
                    <LayoutToggle />
                    {!hideMapLink && <MapLink />}
                </div>
                <Sorting />
            </div>
        </div>
    ) : (
        <div className={`flex justify-between space-x-16 ${className}`}>
            <div className="flex space-x-8">
                <LayoutToggle />
                {!hideMapLink && <MapLink />}
            </div>
            <Sorting />
        </div>
    );
}
